import { isFolderOfTreeType } from 'owa-folders';
import { SHARED_FOLDERS_TREE_TYPE } from 'owa-folders-constants';

export default function isSharedFolder(folderId: string): boolean {
    return isFolderOfTreeType(folderId, SHARED_FOLDERS_TREE_TYPE);
}
